import { render, staticRenderFns } from "./SettingsVanityId.vue?vue&type=template&id=27dd70a2&"
import script from "./SettingsVanityId.vue?vue&type=script&lang=js&"
export * from "./SettingsVanityId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports